import { Ref } from '@vue/composition-api';
import { createNamespacedHelpers } from 'vuex-composition-helpers';

import { formatPrice } from '~/components/bloczki/components/bloczki-functions/bloczek-cena/getBloczekCena';
import { BloczekMarker } from '~/components/map/types/marker/BloczekMarker';
import IBloczekMarkerConfig from '~/components/map/types/marker/config/IBloczekMarkerConfig';
import IMarkerIcon from '~/components/map/types/marker/IMarkerIcon';
import MarkerColorEnum from '~/components/map/types/marker/MarkerColorEnum';
import markerMetrics, { IMarkerMetrics } from '~/consts/markeryMetrics';
import rainbowImages from '~/consts/rainbowImages';

import buildMarkerSvgUrl from './buildMarkerSvgUrl';

const buildMarkerSvg = (marker: BloczekMarker, activeMarker: Ref<BloczekMarker>): IMarkerIcon => {
  const { useGetters } = createNamespacedHelpers('obrazkiBase64');
  const { getImage } = useGetters(['getImage']);
  const hotelUrl = rainbowImages.markerHotel.url;
  const checkUrl = rainbowImages.markerCheck.url;
  const hotelImage = getImage.value(hotelUrl);
  const checkImage = getImage.value(checkUrl);

  const isActive = marker.Id === activeMarker.value?.Id;
  const fillColor = MarkerColorEnum.HOTEL;
  const textBackgroundColor = !isActive ? MarkerColorEnum.INACTIVE_BACKGROUND : MarkerColorEnum.ACTIVE_BACKGROUND;
  const textColor = !isActive ? MarkerColorEnum.INACTIVE_TEXT : MarkerColorEnum.ACTIVE_TEXT;
  const textBorderColor = MarkerColorEnum.HOTEL;
  const iconBase64 = hotelImage && hotelImage.base64 ? hotelImage.base64 : '';
  const checkBase64 = isActive && checkImage && checkImage.base64 ? checkImage.base64 : '';
  const metrics: IMarkerMetrics = isActive ? markerMetrics.defaultActiveMarker : markerMetrics.defaultMarker;
  const text: string = marker.Cena ? `${formatPrice(marker.Cena)} zł` : '';

  const markerConfig: IBloczekMarkerConfig = {
    text,
    fillColor,
    textBackgroundColor,
    textColor,
    textBorderColor,
    iconBase64,
    checkBase64,
    metrics,
  };

  return {
    url: buildMarkerSvgUrl(markerConfig),
  };
};
export default buildMarkerSvg;
